
import { Howl } from 'howler'
import hitSound from '../../audios/magica-hit.mp3'
import lossSound from '../../audios/magica-loss.mp3'
import winSound from '../../audios/magica-win.mp3'
import windSound from '../../audios/game-background.mp3'

export const hitSfx = new Howl({ src: [hitSound] })

export const lossSfx = new Howl({ src: [lossSound] })

export const winSfx = new Howl({ src: [winSound] })

export const windFlowSfx = new Howl({ src: [windSound], loop: true })
